module.exports = __webpack_public_path__ + "static/media/addition.ab09be9c.svg";